import { upperFirst, startCase } from "lodash";

export const humanize = (str) => upperFirst(startCase(str).toLowerCase());
